// @ts-nocheck

import React from 'react';
import * as Accordion from '@radix-ui/react-accordion';
import classNames from 'classnames';
import { ChevronDownIcon } from '@radix-ui/react-icons';
import './customer_segment_features.css';
import styled from 'styled-components';
import {getMonthlyPrice} from './common';
import {useSearchParams} from 'react-router-dom';

const CustomerSegmentFeatures = () => {
  const [searchParams] = useSearchParams();
  const priceOverride = searchParams.get("monthly-price-override");
  return (
    <AccordionWrapper>
      <Title>How we help you <NoWrap>Sing Your Part</NoWrap></Title>
      <Accordion.Root className="AccordionRoot" type="single" defaultValue="item-1" collapsible>
        <Accordion.Item className="AccordionItem" value="item-1">
          <AccordionTrigger>Church Partnerships</AccordionTrigger>
          <AccordionContent>
            <Header>Included</Header>
            <List>
              <ListItem>Curate weekly content for all church families</ListItem>
              <ListItem>Build your church's hymnal, accessible to everyone in the congregation</ListItem>
              <ListItem>View song history, most commonly sung music</ListItem>
              <ListItem>Upload custom music that isn't in the app yet</ListItem>
            </List>
            <Header>Coming Soon</Header>
            <List>
              <ListItem>In-app song editing/curation tools</ListItem>
              <ListItem>Liturgy calendar planners</ListItem>
              <ListItem>Live data on congregation usage</ListItem>
            </List>
            <LetsTalkWrapper>
              <LetsTalk href="https://calendar.app.google/gnnXn7zGBiB1fN469" target="_blank">Let's Talk</LetsTalk>
            </LetsTalkWrapper>
          </AccordionContent>
        </Accordion.Item>

        <Accordion.Item className="AccordionItem" value="item-2">
          <AccordionTrigger>Small Groups (coming soon)</AccordionTrigger>
          <AccordionContent>
            <List>
              <ListItem>Create a group of 5-15 members</ListItem>
              <ListItem>Curate weekly or monthly content to members</ListItem>
              <ListItem>Data & recommendations on songs to learn</ListItem>
            </List>
            <PriceWrapper>
              <Price>$15 - 25 / month</Price>
            </PriceWrapper>
          </AccordionContent>
        </Accordion.Item>

        <Accordion.Item className="AccordionItem" value="item-3">
          <AccordionTrigger>Family Plan</AccordionTrigger>
          <AccordionContent>
            <Header>Included</Header>
            <List>
              <ListItem>Access to full library of hymnals</ListItem>
              <ListItem>Favorites list for every family member</ListItem>
              <ListItem>No limit on number of devices</ListItem>
            </List>
            <Header>Coming Soon</Header>
            <List>
              <ListItem>Family worship singing plans</ListItem>
              <ListItem>Practice schedules & goals</ListItem>
              <ListItem>Church calendar song recommendations</ListItem>
            </List>
            <PriceWrapper>
              <Price>${getMonthlyPrice(priceOverride)} / month</Price>
            </PriceWrapper>
          </AccordionContent>
        </Accordion.Item>
      </Accordion.Root>
    </AccordionWrapper>
  )
}

const Title = styled.div`
  font-family: JostSemiBold, sans-serif;
  font-size: 1.5em;
  margin: 15px;
`

const NoWrap = styled.span`
  display: inline-block;
`

const AccordionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 5% 5% 5%;
  //overflow-y: scroll;
  //height: 100%;
`

const Header = styled.div`
  font-family: JostSemiBold, sans-serif;
  text-align: left;
`

const List = styled.ul`
  list-style-type: disc;
  text-align: left;
`

const ListItem = styled.li`
`

const LetsTalkWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`

const LetsTalk = styled.a`
  // position: absolute;
  //bottom: 20px;
  //right: 20px;
  font-family: JostSemiBold, sans-serif;
  font-size: 1.25em;
  color: white;
  background-color: #5200BB;
  padding: 5px 20px;
  border-radius: 30px;
  cursor: pointer;
`

const PriceWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`

const Price = styled.div`
  font-family: JostSemiBold, sans-serif;
`

const AccordionTrigger = React.forwardRef(({ children, className, ...props }, forwardedRef) => (
    <Accordion.Header className="AccordionHeader">
      <Accordion.Trigger
          className={classNames('AccordionTrigger', className)}
          {...props}
          ref={forwardedRef}
      >
        {children}
        <ChevronDownIcon className="AccordionChevron" aria-hidden />
      </Accordion.Trigger>
    </Accordion.Header>
));

const AccordionContent = React.forwardRef(({ children, className, ...props }, forwardedRef) => (
    <Accordion.Content
        className={classNames('AccordionContent', className)}
        {...props}
        ref={forwardedRef}
    >
      <div className="AccordionContentText">{children}</div>
    </Accordion.Content>
));

export default CustomerSegmentFeatures;
